import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';
dayjs.extend(utc);
dayjs.extend(timezone);

// Lib
import { APPROVED } from '@/lib/scheduler/postStatus';

const PostEventSettings = ({
    post,
    timezone,
    onPreview = () => {
        /** */
    },
    onClickReSchedulePost = () => {
        /** */
    },
    onClickEditPost = () => {
        /** */
    },
    toggleDeleteModal = () => {
        /** */
    },
    hideDuplicateButton = false
}) => {
    const dateNow = dayjs().utc().tz(timezone).format();
    const isFuture = dayjs(post.scheduled_at).utc().tz(timezone).isAfter(dateNow);
    const isDraggableFeedPreview = post?.id?.toString().split('-')[0] !== 'draggable';

    return (
        <div className="flex min-w-[5.25rem] flex-col space-y-1 p-1.5 text-xs">
            <PostEventSettings.PreviewButton
                post={post}
                onPreview={onPreview}
                isFuture={isFuture}
            />
            <PostEventSettings.DuplicateButton
                post={post}
                onClickDuplicatePost={onClickReSchedulePost}
                hideDuplicateButton={hideDuplicateButton}
            />
            <PostEventSettings.EditButton
                post={post}
                onClickEditPost={onClickEditPost}
                isFuture={isFuture && isDraggableFeedPreview}
            />
            <PostEventSettings.DeleteButton toggleDeleteModal={toggleDeleteModal} />
        </div>
    );
};

PostEventSettings.propTypes = {
    post: PropTypes.object.isRequired,
    timezone: PropTypes.string.isRequired,
    toggleDeleteModal: PropTypes.func
};

const PreviewButton = ({ isFuture, onPreview, post }) => {
    const { t } = useTranslation('scheduler');

    if (isFuture) {
        return null;
    }

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                onPreview(post);
            }}
            className="p-1.5 text-left text-icoGray-500 hover:bg-icoBlue-100 hover:text-icoBlue dark:text-icoDarkMode-wolf dark:hover:bg-icoBlue/20 dark:hover:text-icoBlue">
            {t('preview')}
        </button>
    );
};

PostEventSettings.PreviewButton = PreviewButton;

const EditButton = ({ post, isFuture, onClickEditPost }) => {
    const { t } = useTranslation('commons');

    if (!isFuture) {
        return null;
    }

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                onClickEditPost(post);
            }}
            className="p-1.5 text-left text-icoGray-500 hover:bg-icoBlue-100 hover:text-icoBlue dark:text-icoDarkMode-wolf dark:hover:bg-icoBlue/20 dark:hover:text-icoBlue">
            {t('edit')}
        </button>
    );
};

PostEventSettings.EditButton = EditButton;

const DuplicateButton = ({ post, onClickDuplicatePost, hideDuplicateButton }) => {
    const { t } = useTranslation('scheduler');

    if (hideDuplicateButton) {
        return null;
    }

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                onClickDuplicatePost(post);
            }}
            className="p-1.5 text-left text-icoBlue hover:bg-icoBlue-100 dark:hover:bg-icoBlue/20">
            {t('duplicate')}
        </button>
    );
};

PostEventSettings.DuplicateButton = DuplicateButton;

const ScheduleButton = ({ post, isFuture }) => {
    const { t } = useTranslation('scheduler');

    if (!isFuture || post.state !== APPROVED) {
        return null;
    }

    return (
        <button className="p-1.5 text-left text-icoBlue hover:bg-icoBlue-100 dark:hover:bg-icoBlue/20">
            {t('schedule')}
        </button>
    );
};

PostEventSettings.ScheduleButton = ScheduleButton;

const DeleteButton = ({
    toggleDeleteModal = () => {
        /** */
    }
}) => {
    const { t } = useTranslation('scheduler');
    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                toggleDeleteModal();
            }}
            className="p-1.5 text-left text-icoRed hover:bg-icoRed-100 dark:text-icoDarkMode-red dark:hover:bg-icoRed/20">
            {t('commons:delete')}
        </button>
    );
};

PostEventSettings.DeleteButton = DeleteButton;

export default PostEventSettings;
